import { DatemorphISOString } from 'crossref-openapi-client-ts';
import * as E from 'fp-ts/lib/Either';
import * as A from 'fp-ts/lib/Array';
import { pipe } from 'fp-ts/lib/function';
import * as D from '@docmaps/sdk';
import { mapLeftToUnknownError, nameForAuthor } from '../../utils';
import { Eq } from 'fp-ts/lib/string';
const typeOverrides = {
    'posted-content': 'preprint',
    'peer-review': 'review',
};
function overrideContentType(contentType) {
    return typeOverrides[contentType] || contentType;
}
export function thingForCrossrefWork(work) {
    return {
        published: DatemorphISOString(work.published || work.created),
        doi: work.DOI,
        type: overrideContentType(work.type),
    };
}
export function decodeActionForWork(work) {
    return pipe(E.Do, E.bind('wo', () => pipe(work, thingForCrossrefWork, E.right)), E.bind('wa', () => pipe(work.author || [], A.map((a) => ({
        type: 'person',
        name: nameForAuthor(a),
    })), E.traverseArray((a) => pipe(a, D.Actor.decode, mapLeftToUnknownError('decoding actor in decodeActionForWork'))), E.map((auths) => auths.map((a) => ({
        actor: a,
        role: 'author',
    }))))), E.chain(({ wo, wa }) => pipe({
        participants: wa,
        outputs: [wo],
    }, D.Action.decode, mapLeftToUnknownError('decoding action in decodeActionForWork'))));
}
export function relatedDoisForWork(w, relation) {
    const reviews = w.relation?.[relation];
    if (!reviews) {
        return [];
    }
    return pipe(reviews, A.map((wre) => wre.id), A.uniq(Eq));
}
//# sourceMappingURL=functions.js.map